@if (documentListItem) {
  <div>
    <div class="date-category-name">{{ documentListItem.groupCategory }}</div>
    @for (document of documentListItem.documents; track document) {
      <div class="document-list-item" [title]="document.name">
        <div class="document-details">
          <rkt-icon name="report" class="rocket-icon"></rkt-icon>
          <div class="document-title">
            <div class="report-name">{{ $safeNavigationMigration(document?.name) | titlecase }}</div>
            <div class="document-timestamp">{{ document.createdAt | date: 'medium' }}</div>
          </div>
        </div>
        <div class="document-actions">
          @if (document?.pdfStatementPath) {
            <button class="file-icon" (click)="exportDocument(document.name, document.id, 'PDF', false)" title="Preview Report">
              <rkt-icon name="view-file" class="rocket-icon"></rkt-icon>
            </button>
          }
          <button (click)="showDownloadModal(document)" title="Download Report">
            <rkt-icon name="download" class="rocket-icon"></rkt-icon>
          </button>
        </div>
      </div>
    }
  </div>
}
